import React, { useCallback, useMemo } from "react";
import * as R from "ramda";
import { useTranslation } from "react-i18next";

import Range from "../../../../../components/Range";
import * as gtag from "../../../../../lib/gtag";

import { Title, Container } from "./FilterComponents";

const experiences = [0, 0.25, 0.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const labels = [
  "0",
  "3",
  "6",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "+ 10"
];

function getValueFromRange(range) {
  const [minRange, maxRange] = range;
  const value = [experiences[minRange], experiences[maxRange]];
  return value;
}

// inverse from getValueFromRange
function getRangeFromValue(value) {
  const [minValue, maxValue] = value;
  const min = R.findIndex(R.equals(minValue), experiences);
  const max = R.findIndex(R.equals(maxValue), experiences);
  return [min, max];
}

function getLabel(t, value, index) {
  if (index === 0)
    return t("opportunity:candidates.experienceFilter.noExperience");
  else if (index < 3)
    return t("opportunity:candidates.experienceFilter.months", {
      months: value
    });
  else
    return t("opportunity:candidates.experienceFilter.years", {
      years: value
    });
}

function ExperienceFilters({ loading, onChange, value }) {
  const { t } = useTranslation();
  const rangeValue = useMemo(() => getRangeFromValue(value), [value]);

  const handleChange = useCallback(
    range => !loading && onChange(getValueFromRange(range)),
    [loading, onChange]
  );

  const options = useMemo(
    () =>
      labels.map((value, index) => ({
        label: getLabel(t, value, index),
        value: index
      })),
    [t]
  );

  return (
    <details open={value && !R.isEmpty(value) && !R.equals(value, [0, 10])}>
      <Title>
        <h4>{t("opportunity:candidates.experienceFilter.title")}</h4>
      </Title>
      <Container>
        <Range
          disabled={loading}
          onChange={e => {
            handleChange(e);
            gtag.event({
              category: "VacancyCandidates",
              action: `filterWorkExperience`
            });
          }}
          options={options}
          value={rangeValue}
        />
      </Container>
    </details>
  );
}

export default ExperienceFilters;
